import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC } from 'shared/map-search/constants/config/experiments';
import { useApplicationContext } from 'shared/map-search/containers/ApplicationContext';
import { selectExperiments } from 'shared/map-search/selectors/experiments';
import { TMapBounds } from 'shared/map-search/types/mapBounds';
import { IApplicationState } from 'shared/map-search/types/redux';
import { isAbUseExperimentActive } from 'shared/map-search/utils/experiments';

import { useFeaturesContext } from '../context';
import { isResultablePrecision } from './isResultablePrecision';

interface IResultabilityManagerProps {
  onResultabilityChange({ isResultable, isClusterable }: { isResultable: boolean; isClusterable: boolean }): void;
}

const DEFAULT_CLUSTER_PRECISION = 7;

/**
 * @description
 * Менеджер для управления флагом возможности открытия выдачи по тапу на пин
 */
export const ResultabilityManager: React.FC<IResultabilityManagerProps> = ({ onResultabilityChange }) => {
  const { config } = useApplicationContext();
  const { pointsLayer, hotspotsLayer } = useFeaturesContext();
  const isDesktop = useDeviceType() === 'desktop';
  const { precision } = useSelector<IApplicationState, TMapBounds>(state => state.mapBounds);
  const experiments = useSelector(selectExperiments);
  const isExperimentActive = isAbUseExperimentActive(experiments, AUD_MOBILE_BX1047_SINGLE_PIN_LOGIC, 'B');
  const clusterPrecision =
    (isExperimentActive && isDesktop && config.get<number>('mapSearchFrontend.clusterPrecision')) ||
    DEFAULT_CLUSTER_PRECISION;

  const isResultableByPrecision = isResultablePrecision({ config, experiments, isDesktop, precision });
  const isClusterableByPrecision = precision >= clusterPrecision;

  React.useEffect(() => {
    pointsLayer.isResultable = isResultableByPrecision && isClusterableByPrecision;
    pointsLayer.layer.update();
    hotspotsLayer.isResultable = isResultableByPrecision && isClusterableByPrecision;
    hotspotsLayer.layer.update();

    onResultabilityChange({ isResultable: isResultableByPrecision, isClusterable: isClusterableByPrecision });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isResultableByPrecision, isClusterableByPrecision]);

  return null;
};
